<template>
  <Dialog
    v-model:visible="visibleLocal"
    @hide="$emit('close')"
    maximizable
    modal
    header="История изменений"
    :style="{ width: '70vw' }"
    style="max-height: 70vh"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <p class="m-0">
      <DataTable :value="items">
        <Column field="action" header="Действие">
          <template #body="slotProps">
            <span v-if="slotProps.data.operation_type">
              {{ store.operationsMap.get(slotProps.data.operation_type) }}
            </span>
            <span v-else>-</span>
          </template></Column
        >
        <Column field="user" header="Пользователь">
          <template #body="slotProps">
            <span v-if="slotProps.data.changed_by">
              {{ getUserName(slotProps.data.changed_by) }}
            </span>
            <span v-else>-</span>
          </template>
        </Column>
        <Column field="time" header="Дата и время">
          <template #body="slotProps">
            {{ convertDateFromUTC(slotProps.data.changed_at) }}
          </template>
        </Column>
        <Column field="changes" header="Что изменилось">
          <template #body="slotProps">
            <div
              v-if="slotProps.data.operation_type == 'UPDATE' || creationSkip"
            >
              <div
                class="m-b-4"
                v-for="ch in getFilteredChanges(slotProps.data.changes)"
                :key="ch.field"
              >
                {{ ch.field }}: с <span class="f-w-600">{{ ch.old }}</span> на
                <span class="f-w-600">{{ ch.new }}</span>
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </Column>
      </DataTable>
    </p>
  </Dialog>
</template>

<script lang="ts" setup>
import { ref, watch, computed } from "vue";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { getUserName } from "@/services/utils/Names";
import { useHistoryStore } from "@/store/history/history";

import { convertDateFromUTC } from "@/services/utils/DateParser";

const store = useHistoryStore();

const props = defineProps<{
  items: any[];
  visible: boolean;
  creationSkip?: boolean;
}>();

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);

const getFilteredChanges = (changes: any) => {
  const changesResult = [] as HistoryLog[];

  changes.forEach((element: HistoryLog) => {
    if (element.old != element.new) {
      if (element.new === "" || element.new == null)
        element.new = "'пустое значение'";
      if (element.old === "" || element.old == null)
        element.old = "'пустое значение'";
      changesResult.push(element);
    }
  });
  return changesResult;
};

interface HistoryLog {
  field: string;
  new: any;
  old: any;
}
</script>
